// extracted by mini-css-extract-plugin
module.exports = {"skuNameContainer":"SKUNameRenderer_skuNameContainer_2IVnC","textContainer":"SKUNameRenderer_textContainer_3nbmm"};